import { Link } from 'react-router-dom';
import { RegisterForm } from '../components/RegisterForm';

export function Register() {
  return (
    <div className="mx-auto max-w-xl px-4 py-12 md:px-6 md:py-16">
      <div className="rounded-2xl border border-white/[0.08] bg-[var(--home-zone-dark)]/50 p-6 shadow-[0_24px_60px_-40px_rgba(0,0,0,0.55)] ring-1 ring-white/[0.04] backdrop-blur-sm md:p-8">
        <div className="mb-6 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.08em] text-[var(--home-text-on-dark)]"
          >
            <span
              className="h-2 w-2 shrink-0 rounded-full bg-[var(--header-shell-bg)] shadow-[0_0_10px_rgba(244_114_182/0.55)]"
              aria-hidden
            />
            <span className="text-[var(--header-shell-bg)]">Breckenridge</span>
            <span className="font-normal text-[var(--home-miami-blue)]">Capital</span>
          </Link>
          <h1 className="mt-4 font-body text-lg font-semibold leading-snug text-[var(--home-text-on-dark)] md:text-xl">
            Invest with Breckenridge Capital
          </h1>
        </div>
        <p className="text-center font-body text-sm text-[var(--home-muted-on-dark)]">
          Prefer the full onboarding experience?{' '}
          <Link to="/getstarted" className="font-medium text-[var(--home-miami-blue)] underline-offset-4 hover:underline">
            Get started
          </Link>
        </p>
        <div className="mt-6">
          <RegisterForm showLoginLink />
        </div>
      </div>
    </div>
  );
}
